import { QueryFunctionContext } from 'react-query'
import request from 'services/axios'

export const getGroupAllPayments = async () => {
    const { data }: { data: Array<IGetAllPayment> } = await request.get(
        '/api/v1/payment/group-all-payment/init/'
    )
    return data
}

export const getBoxGroupAllPayments = async (ctx: QueryFunctionContext) => {
    const { data }: { data: Array<IGetAllPayment> } = await request.get(
        `/api/v1/payment/group-all-payment/init/?box_type=mnp&box_id=${ctx.queryKey[1]}`
    )
    return data
}
export const initTransaction = async (ctx: QueryFunctionContext) => {
    const { data }: { data: IInitTransaction } = await request.post(
        '/api/v1/payment/init/?os_type=android&app_version=1.891.1',
        [
            {
                id: ctx.queryKey[1],
                type: 'psp',
                amount: ctx.queryKey[3],
                cashin_type: ctx.queryKey[2],
                paid_obj_id: 0,
            },
        ]
    )
    return data
}

export const getTransactions = async () => {
    const { data } = await request.get('/api/v1/payment/transactions/')
    return data
}

export const postTransactions = async (payload: ITransactionPayload) => {
    const { data }: { data: IInitTransaction } = await request.post(
        '/api/v1/payment/transactions/',
        [payload]
    )
    return data
}

/**
 * The same endpoint, for SEVERAL transactions in one payment.
 *
 * `postTransactions` wraps its single payload in an array itself, so handing it
 * an array posts `[[{…},{…}]]` — a list inside a list. The serializer runs with
 * `many=True`, sees one "item" that is itself a list and 400s («Expected a
 * dictionary»). That is what every پرداخت گروهی attempt was doing.
 *
 * The list is the body, exactly as `payCashboxWinners` posts it. With more than
 * one item the backend synthesises a MOTHER transaction over them
 * (`TransactionListSerializer.save`) and answers with it, so `pay_url` here is
 * the one redirect that settles the whole batch.
 */
export const postTransactionBatch = async (
    payload: Array<ITransactionPayload>
) => {
    const { data }: { data: ITransactionBatchResult } = await request.post(
        '/api/v1/payment/transactions/',
        payload
    )
    return data
}

export const postGatewayPayment = async (payload: IGatewayPaymentPayload) => {
    const { data }: { data: IinitGatewayPayment } = await request.post(
        '/api/v2/payment/gateways/gateway-payment/',
        payload
    )
    return data
}

export const postGatewayPaymentOneItem = async (
    payload: IGatewayPaymentPayload
) => {
    const { data }: { data: IinitGatewayPayment } = await request.post(
        '/api/v2/payment/gateways/gateway-payment/',
        payload
    )
    return data
}

export const postSetTransactionWithWallet = async (payload: IPaymentData) => {
    try {
        const response = await request.post(
            `/api/v1/payment/moneypools/${payload?.transaction?.ctx_id}/moneypool-cashins/`,
            [payload]
        )
        return response.data
    } catch (error) {
        console.error('Error posting transaction:', error)
        throw error
    }
}

export const postGatewayPaymentOneItemInstallment = async (
    payload: IGatewayPaymentPayload
) => {
    const { data }: { data: IinitGatewayPayment } = await request.post(
        '/api/v2/payment/gateways/gateway-payment/',
        payload
    )
    return data
}

export const getOnePaymentMoneyPools = async (ctx: QueryFunctionContext) => {
    const { data }: { data: Array<IGetAllPayment> } = await request.get(
        `/api/v1/payment/group-all-payment/init/?box_type=mnp&box_id=${ctx.queryKey[1]}`
    )
    return data
}

export const doGroupPay = async (ctx: QueryFunctionContext) => {
    if (ctx.queryKey[0]) {
        const { status }: any = await request.post(
            `/api/v1/payment/group-all-payment/pay/`,
            ctx.queryKey[0]
        )
        return status
    }
}
export const addOnlinePayForOther = async (
    payload: IAddOnlinePayForOtherPayload
) => {
    const { data }: { data: IAddOnlinePayForOthersResult } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/moneypool-cashins/`,
        [
            {
                poolship: payload.poolShip,
                amount: payload.amount,
                type: payload.type ? payload.type : 'cnp',
                tag: '',
                transaction: {
                    ctx_id: payload.ctxId,
                    ctx_type: 'mnp',
                    destination: payload.trustState === 'trst' ? 'hbb' : 'bba',
                    gateway: payload.gateway,
                    is_group_pay: false,
                    payer_name: '',
                    receiver: payload.poolShip,
                    receiver_name: '',
                    source: payload?.source ? payload.source : 'gtw',
                    state: '',
                    state_time: '',
                    transaction_code: '',
                    ...(payload.commission && {
                        commission: payload.commission,
                    }),
                },
            },
        ]
    )
    return data
}

export const addJustAddPayForOther = async (payload: IPayloadForJustAdd) => {
    const { data }: { data: IAddOnlinePayForOthersResult } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/moneypool-cashins/`,
        [
            {
                poolship: payload.poolShip,
                amount: payload.amount,
                type: 'cnp',
                tag: '',
            },
        ]
    )
    return data
}

export const addOnlinePayForOtherInLoan = async (
    payload: IAddOnlinePayForOtherInLoanPayload
) => {
    const { data }: { data: IAddOnlinePayForOthersResult } = await request.post(
        `/api/v1/payment/moneypools/${payload.moneyPool}/loans/${payload.loan}/pay-installment/`,

        {
            poolship: payload.poolShip,
            amount: payload.amount,
            type: payload.type ? payload.type : 'cnp',
            tag: '',
            transaction: {
                ctx_id: payload.ctxId,
                ctx_type: 'mnp',
                destination: payload.trustState === 'trst' ? 'hbb' : 'bba',
                gateway: payload.gateway,
                is_group_pay: false,
                payer_name: '',
                receiver: payload.poolShip,
                receiver_name: '',
                source: payload?.source ? payload.source : 'gtw',
                state: '',
                state_time: '',
                transaction_code: '',
                ...(payload.commission && {
                    commission: payload.commission,
                }),
            },
        }
    )
    return data
}
